import createVueComponent from '../createVueComponent';

const Crown = createVueComponent('CrownIcon', [
  ['path', { d: 'M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14' }],
]);

export default Crown;
